import { jsx as S } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useMemo as j, useCallback as w, useRef as h, useEffect as i } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { useTimeRangeSelection as x } from "./useTimeRangeSelection.js";
import D from "../../../FormFields/Select/Select.js";
const z = ({
  calendarRef: t,
  onTimeRangeSelected: o,
  timestamp: s,
  ...O
}) => {
  const { customSelection: f, from: u, onSelection: l, options: m, selectedOption: r, to: c } = x(O), b = j(() => Object.freeze(m.map((e) => ({ id: e, name: e }))), [m]), C = w(({ target: e }) => l(e == null ? void 0 : e.value), [l]), n = h(!0), p = h(s);
  return i(() => {
    t != null && t.current && u && c && (n.current = !0, t.current.from = new Date(u), t.current.to = new Date(c));
  }, [t, u, c]), i(() => {
    p.current !== s && (p.current = s, n.current ? n.current = !1 : f());
  }, [f, s]), i(() => {
    r && (o == null || o(r));
  }, [r, o]), /* @__PURE__ */ S(
    D,
    {
      setToTargetWidth: !0,
      items: b,
      filterable: !1,
      multiSelect: !1,
      onChange: C,
      selected: r
    }
  );
};
export {
  z as default
};
